import React from 'react';
import { UserLookup } from '../components/UserLookup';

export default function Home() {
  return <UserLookup />;
}
